/* src/app/modules/home/pages/dashboard/dashboard.component.scss */
img {
  max-width: 70%;
}
.dashboard-welcome-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5em;
  max-width: 600px;
}
.dashboard-welcome-text {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4em;
}
.dashboard-welcome-title {
  color: var(--ion-color-secondary-contrast);
  font-weight: 490;
  letter-spacing: 0.3px;
  display: block;
  line-height: 1.2;
}
.dashboard-welcome-subtitle {
  color: var(--ion-color-secondary-contrast);
  opacity: 0.75;
  font-size: 1.25rem;
  display: block;
}
@media only screen and (min-width: 720px) {
  .dashboard-welcome-title {
    font-size: 2rem;
  }
}
@media only screen and (max-width: 720px) {
  .dashboard-welcome-title {
    font-size: 1.5rem;
  }
  .dashboard-welcome-card {
    margin: 0 1em 1.5em;
    padding: 1.25em 1.25em;
  }
}
ion-card {
  width: 150px;
  height: 150px;
}
/*# sourceMappingURL=dashboard.component-7QQD2IVY.css.map */
